/**
 * Shown instead of `SafeRoutes` when the user holds `page.safe.view` but has no Salesforce session.
 *
 * `api/db/safe/*` refuses those callers (`HasSalesforceSession`), so the assessment would load and
 * then fail on its first request. A bare redirect to `/unauthorized` would be misleading — the user
 * *is* authorized, they are just not connected — so this offers the fix instead. Reachable by a
 * bookmark or a stale tab; the nav hides the SAFE entries under the same condition.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HbrButton } from '@harbor/elements-react-standalone';
import { useAuthenticateUser } from '../../hooks/useAuthenticateUser';

export default function SafeSalesforceRequired() {
  const navigate = useNavigate();
  const { startSalesforceLinkLogin } = useAuthenticateUser();

  return (
    <div style={{ padding: 24, maxWidth: 900 }}>
      <h2 style={{ marginTop: 0, marginBottom: 8 }}>Salesforce required for SAFE</h2>
      <p style={{ marginTop: 0, marginBottom: 16 }}>
        A SAFE assessment is scoped to a customer opportunity, so it needs a connected Salesforce
        session. Your Cisco sign-in is valid — connect Salesforce to continue.
      </p>

      <div style={{ display: 'flex', gap: 12 }}>
        <HbrButton onClick={startSalesforceLinkLogin}>Connect Salesforce</HbrButton>
        <HbrButton sentiment="secondary" onClick={() => navigate('/')}>
          Go to Home
        </HbrButton>
      </div>
    </div>
  );
}
